import DictSelectPageComponent from './index.vue'

export default DictSelectPageComponent
